import { TermItem } from '@/models/quote-template';
import { QuoteTermItemService } from '@/services/quote-term-service';
import { ActionTree, GetterTree, MutationTree } from 'vuex';

const quoteTermService = new QuoteTermItemService();

export const state = {
  termItems: [] as TermItem[]
};

type QuotesState = typeof state;

export const mutations: MutationTree<QuotesState> = {
  SET_QUOTE_TERM_ITEMS(state, payload: TermItem[]) {
    state.termItems = payload;
  },

  ADD_QUOTE_TERM_ITEM(state, payload: TermItem) {
    state.termItems.push(payload);
  },

  UPDATE_QUOTE_TERM_ITEM(state, payload: TermItem) {
    const index = state.termItems.findIndex(
      (quoteTerm: TermItem) => quoteTerm.id === payload.id
    );
    state.termItems.splice(index, 1, payload);
  },

  REMOVE_QUOTE_TERM_ITEM(state, payload: number) {
    const index = state.termItems.findIndex(
      (quoteTerm: TermItem) => quoteTerm.id === payload
    );
    state.termItems.splice(index, 1);
  }
};

export const actions: ActionTree<QuotesState, QuotesState> = {
  createQuoteTerm: async ({ commit }, payload: TermItem) =>
    quoteTermService
      .createQuoteTerm(payload)
      .then((quoteTerm: TermItem) => commit('ADD_QUOTE_TERM_ITEM', quoteTerm)),

  fetchQuoteTerms: async ({ commit }, language?: string) =>
    quoteTermService.fetchQuoteTerms(language).then((termItems: TermItem[]) => {
      commit('SET_QUOTE_TERM_ITEMS', termItems);
    }),

  fetchQuoteTerm: async ({ commit }, payload: number) =>
    quoteTermService.fetchQuoteTerm(payload).then((quoteTerm: TermItem) => {
      const index = state.termItems.findIndex(
        (v: TermItem) => v.id === quoteTerm.id
      );
      if (index === -1) {
        commit('ADD_QUOTE_TERM_ITEM', quoteTerm);
      } else {
        commit('UPDATE_QUOTE_TERM_ITEM', quoteTerm);
      }
      return quoteTerm;
    }),

  updateQuoteTerm: async ({ state, commit }, payload: TermItem) =>
    quoteTermService.updateQuoteTerm(payload).then((quoteTerm: TermItem) => {
      const index = state.termItems.findIndex(
        (v: TermItem) => v.id === quoteTerm.id
      );
      if (index === -1) {
        commit('ADD_QUOTE_TERM_ITEM', quoteTerm);
      } else {
        commit('UPDATE_QUOTE_TERM_ITEM', quoteTerm);
      }
    }),

  deleteQuoteTerm: async ({ commit }, payload: number) =>
    quoteTermService.deleteQuoteTerm(payload).then(() => {
      commit('REMOVE_QUOTE_TERM_ITEM', payload);
    })
};

export const getters: GetterTree<QuotesState, QuotesState> = {
  getQuoteTermById: state => (id: number) =>
    state.termItems.find(quoteTerm => quoteTerm.id === id)
};
